import { PremiumPreviewType, PremiumPreviewData } from '../store/schema/PremiumPreviewData';
import { getEditorBxClient } from '../utils/getEditorBxClient';
import { PremiumPreviewUnit } from '@nlapps/editor-client-web';

/**
 * Enable premium suggestions and set the needed properties on the Editor Client BX
 * in order to display the correct string within the contexual card (days left / suggestions left)
 * This function should be called :
 * 1) when user click on 'try now' button
 * 2) when initializing the Proofing editor plugin
 */
export function enableCritiquesOnBx(
    editorProofingId: string,
    premiumPreviewData: PremiumPreviewData,
    numberOfDaysLeftToUsePremiunSuggestions: number,
    premiumSuggestionsCount: number
): void {
    let premiumPreviewUnit: PremiumPreviewUnit;
    let numberToDisplay: number;
    const editorProofing = getEditorBxClient(
        editorProofingId,
        null /*userCulture*/,
        null /*composeOperation */,
        premiumPreviewData.premiumPreviewStatus,
        null /* augloopSession */
    );

    if (premiumPreviewData.premiumPreviewType === PremiumPreviewType.TimeBased) {
        premiumPreviewUnit = PremiumPreviewUnit.Days;
        numberToDisplay = numberOfDaysLeftToUsePremiunSuggestions;
    } else if (premiumPreviewData.premiumPreviewType === PremiumPreviewType.CountBased) {
        premiumPreviewUnit = PremiumPreviewUnit.Suggestions;
        numberToDisplay = premiumSuggestionsCount;
    }

    editorProofing.setPremiumPreviewActive(true);
    editorProofing.setPreviewCritiquesCount(numberToDisplay, premiumPreviewUnit);
}
